import React from 'react';
import { pageDefinition } from 'site-modules/shared/pages/page';
import { getSrpSeoObject } from 'site-modules/shared/utils/inventory/srp-seo-object';
import { pageDefinitionConfiguration, getPreload } from './usurp-definition';

import { UsurpContainer } from './usurp-container';

export const getPageDefinitionConfig = params => ({
  ...pageDefinitionConfiguration,
  name: 'used_car_inventory_srp',
  preload: (store, props) => getPreload(store, props, params),
  seo: (state, props) => getSrpSeoObject(state, props),
  component: props => <UsurpContainer {...props} isSrpOnUsedCore={params.isSrpOnUsedCore} />,
  chunkName: 'used_srp_core',
});

export default params => pageDefinition(getPageDefinitionConfig(params));
